import Vue from 'vue'
import Vuex from 'vuex'
import currentStat from './currentStat'
import driverPerform from './driverPerform'
import driverPerformV2 from './driverPerformV2'
import summary from './summary'
import driverUser from './driverUser'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    currentStat,
    driverPerform,
    driverPerformV2,
    summary,
    driverUser
  }
})

export default store
